import { createReducer } from "@reduxjs/toolkit"

export const otherReducer = createReducer({}, {

    contactRequest: (state) => {
        state.loading = true;
    },
    contactSuccess: (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
    },
    contactFailure: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },


    courseRequest: (state) => {
        state.loading = true;
    },
    courseSuccess: (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
    },
    courseFailure: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },


    clearError: (state) => {
        state.error = null;
    },
    clearMessage: (state) => {
        state.message = null;
    }
})